import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/VendorWelcome.css';
import bgImage from '../assets/images/area51.png';


const VendorWelcome = () => {
  const navigate = useNavigate();

  return (
    <>


      <div className="mobile-container">
        <div className="mobile-card" style={{ backgroundImage: `url(${bgImage})` }}>
          <div className="overlay"></div>

          <div className="mobile-content">
            <h2>Welcome to</h2>
            <h1>Area 51</h1>
            <p className="subtitle">Unparalleled Deal</p>
            <p className="description">
              Tired of searching for your beloved product at the right price and quality in your area? It’s just a click away to know the best price.
            </p>
            <button className="mobile-btn" onClick={() => navigate('/auth')}>
              Get Started
            </button>
          </div>
        </div>
      </div>

   
    </>
  );
};

export default VendorWelcome;
